// src/components/Layout.tsx
import React from 'react';
import Header from './Header';
import Footer from './Footer/Footer';
import { Outlet, useLocation } from 'react-router-dom';

const Layout: React.FC = () => {
    const location = useLocation();
  
    return (
        <>
            {<Header />}
            <main>
                <Outlet />
            </main>
            { <Footer />}
        </>
    );
};

export default Layout;
